import { ApolloError } from '@apollo/client';
import { ReactNode } from 'react';
import AlertError from './alert-error';

const ApplicationErrorView = (props: { error: ApolloError | undefined; children?: ReactNode }) => {
  if (!props.error) {
    return <div className="hidden" />;
  }

  return (
    <AlertError title="Error" message={props.error.message}>
      {props.children}
    </AlertError>
  );
};

export default ApplicationErrorView;
